"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterTypes = exports.Filter = exports.LocationFilterManager = void 0;

var _v = _interopRequireDefault(require("uuid/v1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FilterTypes = {
  EQUAL: 'eq',
  NOT_EQUAL: 'neq'
};
exports.FilterTypes = FilterTypes;

var Filter = /*#__PURE__*/function () {
  function Filter(property, value, operator, label, preSelected) {
    _classCallCheck(this, Filter);

    this.id = (0, _v["default"])();
    this.property = property;
    this.value = value;
    this.operator = operator === FilterTypes.NOT_EQUAL ? FilterTypes.NOT_EQUAL : FilterTypes.EQUAL;
    this.label = label;
    this.preSelected = preSelected;
  }

  _createClass(Filter, [{
    key: "compare",
    value: function compare(location) {
      if (this.operator === FilterTypes.EQUAL) {
        return location[this.property] === this.value;
      }

      return location[this.property] !== this.value;
    }
  }], [{
    key: "fromSettings",
    value: function fromSettings(data) {
      var filterState = [];
      data.forEach(function (filter) {
        filterState[filter.id] = filter.preSelected;
      });
      return filterState;
    }
  }]);

  return Filter;
}();

exports.Filter = Filter;

var LocationFilterManager = /*#__PURE__*/function () {
  function LocationFilterManager() {
    _classCallCheck(this, LocationFilterManager);

    /**
     *
     * @type {Filter[]}
     */
    this.filters = [];
  }
  /**
   * @param {Filter} filter
   */


  _createClass(LocationFilterManager, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this.filters.push(filter);
    }
    /**
     * @param {Filter} filter
     */

  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.filters.splice(this.filters.findIndex(function (x) {
        return x.id === filter.id;
      }), 1);
    }
  }, {
    key: "resetFilters",
    value: function resetFilters() {
      this.filters = [];
    }
    /**
     * @param {Location} location
     */

  }, {
    key: "compare",
    value: function compare(location) {
      var isValid = true;
      this.filters.forEach(function (filter) {
        if (!filter.compare(location)) {
          isValid = false;
        }
      });
      return isValid;
    }
  }]);

  return LocationFilterManager;
}();

exports.LocationFilterManager = LocationFilterManager;